var render = function render(){var _vm=this,_c=_vm._self._c;return _c('provider-wrapper',{attrs:{"element":_vm.element,"layer":_vm.layer,"inject-key":"publishInfoTable"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }